/**
 * Brand column renderers for the admin lists — status pills, gold class badges,
 * money, and initials-avatar names, matching the delivered mock's `cell()`
 * (`_design/ui_kits/admin/app.jsx`). Drop into AntD `<Table.Column render={...}>`.
 */
import React from 'react';
import { brand, statusColor, money as fmtMoney, initials } from './brand';

const dash = <span style={{ color: brand.sub }}>—</span>;

/** Status pill colored by value (verified/pending/flagged/staff → palette). */
export const renderStatus = (value: unknown): React.ReactNode => {
  if (value === null || value === undefined || value === '') return dash;
  const [fg, bg] = statusColor(value);
  return (
    <span
      style={{
        display: 'inline-block',
        fontFamily: brand.fSans,
        fontWeight: 700,
        fontSize: 11,
        color: fg,
        background: bg,
        padding: '3px 11px',
        borderRadius: 999,
        whiteSpace: 'nowrap',
      }}
    >
      {String(value)}
    </span>
  );
};

/** Gold honor-year class badge. */
export const renderClass = (value: unknown): React.ReactNode => {
  if (!value) return dash;
  return (
    <span
      style={{
        display: 'inline-block',
        fontFamily: brand.fDisplay,
        fontWeight: 700,
        fontSize: 12,
        color: brand.navy900,
        background: brand.goldGrad,
        padding: '2px 11px',
        borderRadius: 999,
      }}
    >
      {String(value)}
    </span>
  );
};

/** Money, navy ink. */
export const renderMoney = (value: unknown): React.ReactNode => {
  if (value === null || value === undefined) return dash;
  return <span style={{ fontFamily: brand.fSans, fontWeight: 700, color: brand.ink }}>{fmtMoney(Number(value))}</span>;
};

/** Jaguar initials avatar + name. */
export const renderAvatarName = (name: unknown): React.ReactNode => {
  const n = String(name ?? '');
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 10 }}>
      <span
        style={{
          width: 30,
          height: 30,
          borderRadius: '50%',
          background: brand.jaguar,
          color: brand.paper,
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontFamily: brand.fDisplay,
          fontWeight: 700,
          fontSize: 11,
          border: '1px solid ' + brand.gold,
          flexShrink: 0,
        }}
      >
        {initials(n) || '—'}
      </span>
      <span style={{ fontFamily: brand.fSans, fontWeight: 600, color: brand.ink }}>{n}</span>
    </span>
  );
};
